<script lang="ts" setup>
import { Header } from '@brighterly/lib-lumee-ui'

import { useScreenWidth } from '@shared/lib/browser'

import HeaderMenu from './HeaderMenu.vue'

defineOptions({
  name: 'MobileFooter',
})

// The DS bottom bar carries the items below 740px; from 740 the top bar does.
const { isMobile } = useScreenWidth()
</script>

<template>
  <div class="mobile-footer">
    <div
      v-if="$slots.default"
      class="mobile-footer__top"
    >
      <slot />
    </div>
    <Header
      v-if="isMobile"
      position="bottom"
    >
      <template #navSlot>
        <HeaderMenu layout="vertical" />
      </template>
    </Header>
  </div>
</template>

<style scoped lang="scss" src="./MobileFooter.scss" />
